var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', [_c('div', {
    staticClass: "custom-search d-flex align-items-center justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-sm-row align-items-center mb-1 justify-content-around"
  }, [_vm.$permissionAbility(_vm.DIVISION_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 btn-md mr-1",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isRowChecked
    },
    on: {
      "click": _vm.restoreSelected
    }
  }, [_vm._v(" Restore Selected ")])] : _vm._e(), _vm.$permissionAbility(_vm.DIVISION_CREATE, _vm.permissions) ? [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "flex-shrink-0 btn-md",
    attrs: {
      "variant": "danger",
      "disabled": !_vm.isRowChecked
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_vm._v(" Delete Selected ")])] : _vm._e()], 2)]), _c('vue-good-table', {
    attrs: {
      "line-numbers": true,
      "mode": "remote",
      "style-class": "vgt-table table-custom-style bordered condensed",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading,
      "rows": _vm.rows,
      "sort-options": {
        enabled: false,
        multipleColumns: true,
        initialSortBy: [{
          field: 'created_at',
          type: 'desc'
        }]
      },
      "select-options": {
        enabled: true
      },
      "columns": _vm.columns,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageLength
      }
    },
    on: {
      "on-selected-rows-change": _vm.selectionChanged,
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange,
      "update:isLoading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      },
      "update:is-loading": function updateIsLoading($event) {
        _vm.isLoading = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$column, _props$row, _props$column2, _props$row2, _props$row3, _props$column3, _props$row4, _props$row5, _props$row5$superviso, _props$row5$superviso2, _props$row6, _props$row6$superviso, _props$row6$superviso2, _props$row7, _props$row7$superviso, _props$row7$superviso2, _props$row8, _props$row8$superviso, _props$row8$superviso2, _props$row9, _props$row9$superviso, _props$row9$superviso2, _props$column4, _props$row10, _props$row10$mileston, _props$row10$mileston2, _props$row11, _props$row11$mileston, _props$row11$mileston2, _props$row12, _props$row12$mileston, _props$row12$mileston2, _props$row13, _props$row13$mileston, _props$row13$mileston2, _props$row14, _props$row14$mileston, _props$row14$mileston2;
        return [(props === null || props === void 0 ? void 0 : (_props$column = props.column) === null || _props$column === void 0 ? void 0 : _props$column.field) === 'format_members' ? [_c('div', {
          staticClass: "table-cell-margin"
        }, [_c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(" Member Count: " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row = props.row) === null || _props$row === void 0 ? void 0 : _props$row.team_count))])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column2 = props.column) === null || _props$column2 === void 0 ? void 0 : _props$column2.field) === 'format_task_subtask_count' ? [_c('div', {
          staticClass: "mt-1 mb-1"
        }, [_c('b', [_vm._v("Task: ")]), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatType(props === null || props === void 0 ? void 0 : (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.tasks_count)))])], 1), _c('div', {
          staticClass: "mt-1"
        }, [_c('b', [_vm._v("SubTask: ")]), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatType(props === null || props === void 0 ? void 0 : (_props$row3 = props.row) === null || _props$row3 === void 0 ? void 0 : _props$row3.sub_tasks_count)))])], 1)] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column3 = props.column) === null || _props$column3 === void 0 ? void 0 : _props$column3.field) == 'format_supervisor' ? [props !== null && props !== void 0 && (_props$row4 = props.row) !== null && _props$row4 !== void 0 && _props$row4.supervisor ? _c('span', [_c('b-avatar', {
          staticClass: "mx-1",
          attrs: {
            "src": props === null || props === void 0 ? void 0 : (_props$row5 = props.row) === null || _props$row5 === void 0 ? void 0 : (_props$row5$superviso = _props$row5.supervisor) === null || _props$row5$superviso === void 0 ? void 0 : (_props$row5$superviso2 = _props$row5$superviso.data) === null || _props$row5$superviso2 === void 0 ? void 0 : _props$row5$superviso2.avatar
          }
        }), _c('div', {
          staticClass: "text-nowrap table-cell-margin"
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : (_props$row6$superviso = _props$row6.supervisor) === null || _props$row6$superviso === void 0 ? void 0 : (_props$row6$superviso2 = _props$row6$superviso.data) === null || _props$row6$superviso2 === void 0 ? void 0 : _props$row6$superviso2.name) + " "), _c('br'), _c('b-link', {
          attrs: {
            "href": 'mailto:' + (props === null || props === void 0 ? void 0 : (_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : (_props$row7$superviso = _props$row7.supervisor) === null || _props$row7$superviso === void 0 ? void 0 : (_props$row7$superviso2 = _props$row7$superviso.data) === null || _props$row7$superviso2 === void 0 ? void 0 : _props$row7$superviso2.email)
          }
        }, [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : (_props$row8$superviso = _props$row8.supervisor) === null || _props$row8$superviso === void 0 ? void 0 : (_props$row8$superviso2 = _props$row8$superviso.data) === null || _props$row8$superviso2 === void 0 ? void 0 : _props$row8$superviso2.email) + " ")]), _c('br'), _c('span', [_vm._v(" " + _vm._s(props === null || props === void 0 ? void 0 : (_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : (_props$row9$superviso = _props$row9.supervisor) === null || _props$row9$superviso === void 0 ? void 0 : (_props$row9$superviso2 = _props$row9$superviso.data) === null || _props$row9$superviso2 === void 0 ? void 0 : _props$row9$superviso2.employee_number) + " ")])], 1)], 1) : _c('span', [_c('div', {
          staticClass: "text-nowrap"
        }, [_c('span', [_vm._v(" Not Supervisor Assigned ")])])])] : _vm._e(), (props === null || props === void 0 ? void 0 : (_props$column4 = props.column) === null || _props$column4 === void 0 ? void 0 : _props$column4.field) === 'format_milestone' ? [props !== null && props !== void 0 && (_props$row10 = props.row) !== null && _props$row10 !== void 0 && (_props$row10$mileston = _props$row10.milestone) !== null && _props$row10$mileston !== void 0 && (_props$row10$mileston2 = _props$row10$mileston.data) !== null && _props$row10$mileston2 !== void 0 && _props$row10$mileston2.title ? _c('div', {
          staticClass: "mt-1"
        }, [_c('span', [_vm._v(_vm._s(props === null || props === void 0 ? void 0 : (_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : (_props$row11$mileston = _props$row11.milestone) === null || _props$row11$mileston === void 0 ? void 0 : (_props$row11$mileston2 = _props$row11$mileston.data) === null || _props$row11$mileston2 === void 0 ? void 0 : _props$row11$mileston2.title) + " "), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatMilestoneType(props === null || props === void 0 ? void 0 : (_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : (_props$row12$mileston = _props$row12.milestone) === null || _props$row12$mileston === void 0 ? void 0 : (_props$row12$mileston2 = _props$row12$mileston.data) === null || _props$row12$mileston2 === void 0 ? void 0 : _props$row12$mileston2.is_extra)))])], 1)]) : _vm._e(), props !== null && props !== void 0 && (_props$row13 = props.row) !== null && _props$row13 !== void 0 && (_props$row13$mileston = _props$row13.milestone) !== null && _props$row13$mileston !== void 0 && (_props$row13$mileston2 = _props$row13$mileston.data) !== null && _props$row13$mileston2 !== void 0 && _props$row13$mileston2.payment_type ? _c('div', {
          staticClass: "mt-1 mb-1"
        }, [_c('b', [_vm._v("Payment Type: ")]), _c('b-badge', {
          attrs: {
            "pill": "",
            "variant": "light-primary"
          }
        }, [_vm._v(_vm._s(_vm.formatType(props === null || props === void 0 ? void 0 : (_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : (_props$row14$mileston = _props$row14.milestone) === null || _props$row14$mileston === void 0 ? void 0 : (_props$row14$mileston2 = _props$row14$mileston.data) === null || _props$row14$mileston2 === void 0 ? void 0 : _props$row14$mileston2.payment_type)))])], 1) : _vm._e()] : _vm._e(), props.column.field === 'action' ? _c('span', [_c('span', [_c('b-dropdown', {
          attrs: {
            "variant": "link",
            "toggle-class": "text-decoration-none",
            "no-caret": ""
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('feather-icon', {
                staticClass: "text-body align-middle mr-25",
                attrs: {
                  "icon": "MoreVerticalIcon",
                  "size": "16"
                }
              })];
            },
            proxy: true
          }], null, true)
        }, [_vm.$permissionAbility(_vm.DIVISION_EDIT, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              var _props$row15;
              return _vm.restore(props === null || props === void 0 ? void 0 : (_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : _props$row15.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "RefreshCcwIcon"
          }
        }), _c('span', [_vm._v("Restore")])], 1)] : _vm._e(), _vm.$permissionAbility(_vm.DIVISION_DELETE, _vm.permissions) ? [_c('b-dropdown-item', {
          on: {
            "click": function click($event) {
              return _vm.onDelete(props.row.id);
            }
          }
        }, [_c('feather-icon', {
          staticClass: "mr-50",
          attrs: {
            "icon": "TrashIcon"
          }
        }), _c('span', [_vm._v(" Delete Permanently")])], 1)] : _vm._e()], 2)], 1)]) : _c('span', [_vm._v(" " + _vm._s(props.formattedRow[props.column.field]) + " ")])];
      }
    }, {
      key: "pagination-bottom",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between flex-wrap"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-0 mt-1"
        }, [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" Showing 1 to ")]), _c('b-form-select', {
          staticClass: "mx-1",
          attrs: {
            "options": ['10', '25', '50', '100', '500']
          },
          on: {
            "input": function input(value) {
              return props.perPageChanged({
                currentPerPage: value
              });
            }
          },
          model: {
            value: _vm.pageLength,
            callback: function callback($$v) {
              _vm.pageLength = $$v;
            },
            expression: "pageLength"
          }
        }), _c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(" of " + _vm._s(props.total) + " entries ")])], 1), _c('div', [_c('b-pagination', {
          staticClass: "mt-1 mb-0",
          attrs: {
            "value": 1,
            "total-rows": props.total,
            "per-page": _vm.pageLength,
            "first-number": "",
            "last-number": "",
            "align": "right",
            "prev-class": "prev-item",
            "next-class": "next-item"
          },
          on: {
            "input": function input(value) {
              return props.pageChanged({
                currentPage: value
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "prev-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronLeftIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }, {
            key: "next-text",
            fn: function fn() {
              return [_c('feather-icon', {
                attrs: {
                  "icon": "ChevronRightIcon",
                  "size": "18"
                }
              })];
            },
            proxy: true
          }], null, true)
        })], 1)])];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }